const guests = ["<50", "50-100", "100-200", ">200"];
export default guests;
